import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useHardFacts } from "@/contexts/classified";
import { FarbweltLogo } from "@/components";
import { FactEnum } from "@/types";
import { formatTextWithHtml } from "@/utils";
export const projectBannerInfoTestId = "cdp-open-form-sticky-project-banner-info";
export const ProjectBannerInfo = () => {
    const { title, facts } = useHardFacts();
    const formattedFacts = (facts === null || facts === void 0 ? void 0 : facts.map((fact) => fact.type === FactEnum.livingSpace ? fact.splitValue : fact.value)) || [];
    const subtitle = formattedFacts
        .filter(Boolean)
        .join("&nbsp;&nbsp;•&nbsp;&nbsp;")
        .replace(/<br\s*\/?>/g, " ");
    return (_jsxs(Box, { display: "flex", gap: "spacing.16", marginLeft: {
            "breakpoint.lg": "spacing.32",
            "breakpoint.xl": "spacing.80",
        }, marginRight: "auto", testId: projectBannerInfoTestId, children: [_jsx(FarbweltLogo, { position: "inherit", testId: `${projectBannerInfoTestId}.Logo` }), _jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", children: [_jsx(Box, { typography: "typography.headline.24.bold", children: title }), _jsx(Box, { typography: "typography.body.14.regular", dangerouslySetInnerHTML: { __html: formatTextWithHtml(subtitle) } })] })] }));
};
